import React, { useEffect, useState } from "react"
import { Card, CardBody, Row, Col, Spinner, Progress } from "reactstrap"
import { DashboardReportTypes } from "constants/layout"
import { get } from "helpers/api_helper"

const CategoryDistribution = () => {
  const [reportType, setReportType] = useState(DashboardReportTypes[0])
  const [loading, setLoading] = useState(true)
  const [productData, setProductData] = useState([])
  const [totalUnits, setTotalUnits] = useState(0)

  useEffect(() => {
    const fetchTopProducts = async () => {
      setLoading(true)
      try {
        const res = await get(`api/org/topproducts/${reportType.value}`)
        if (res.status === 200 && Array.isArray(res.response)) {
          let sumUnits = 0
          res.response.forEach(item => {
            sumUnits += parseInt(item.units) || 0
          })

          setTotalUnits(sumUnits)

          const formattedProducts = res.response.map(item => {
            const count = parseInt(item.units) || 0
            const percent = sumUnits > 0 ? (count / sumUnits) * 100 : 0
            return {
              name: item.title || "Unknown Product",
              count: count,
              percent: percent
            }
          })

          setProductData(formattedProducts)
        } else {
          setProductData([])
          setTotalUnits(0)
        }
      } catch (err) {
        console.error("Error loading top products:", err)
      } finally {
        setLoading(false)
      }
    }
    fetchTopProducts()
  }, [reportType])

  const colors = ["primary", "success", "info", "warning", "danger", "dark"]

  return (
    <Card className="shadow-none border">
      <CardBody className="p-4">
        <div>
          <Row className="mb-3 align-items-center">
            <Col xs="6">
              <h4 className="card-title mb-0 font-size-15">
                <i className="mdi mdi-chart-donut text-primary me-2 font-size-18"></i>
                Top 10 Products
              </h4>
            </Col>
            <Col xs="6">
              <select
                onChange={e => setReportType(JSON.parse(e.target.value))}
                className="form-select form-select-sm"
                value={JSON.stringify(reportType)}
              >
                {DashboardReportTypes.map((v, i) => (
                  <option value={JSON.stringify(v)} key={`PCD_${i}${v.value}`}>
                    {v.title}
                  </option>
                ))}
              </select>
            </Col>
          </Row>

          {loading ? (
            <div className="d-flex justify-content-center py-5">
              <Spinner color="primary" size="sm" />
            </div>
          ) : productData.length === 0 ? (
            <div className="text-center py-5 text-muted">
              <i className="mdi mdi-chart-donut-variant display-4 text-light"></i>
              <p className="mt-2 font-size-13">No sales data found</p>
            </div>
          ) : (
            <div>
              {productData.map((prod, idx) => {
                const color = colors[idx % colors.length]
                return (
                  <div key={idx} className="mb-3">
                    <div className="d-flex align-items-center justify-content-between mb-1 font-size-12">
                      <span className="text-muted fw-medium text-truncate" style={{ maxWidth: '70%' }}>{prod.name}</span>
                      <span className="fw-bold">
                        {prod.count} Units ({prod.percent.toFixed(1)}%)
                      </span>
                    </div>
                    <Progress
                      value={prod.percent}
                      color={color}
                      className="progress-sm"
                      style={{ height: "6px", borderRadius: "10px" }}
                    />
                  </div>
                )
              })}
            </div>
          )}
        </div>

        {!loading && totalUnits > 0 && (
          <div className="border-top pt-3 mt-3 d-flex align-items-center justify-content-between font-size-12">
            <span className="text-muted">Total Units (Top 10):</span>
            <span className="badge bg-primary rounded-pill font-size-12 px-3 py-1 fw-bold">
              {totalUnits} Units
            </span>
          </div>
        )}
      </CardBody>
    </Card>
  )
}

export default CategoryDistribution
